<template>
  <div class="gutter-horizontal">

    <h1>Organisms</h1>

    <!-- container -->
    <div class="gutter-vertical">

      <!-- organisms -->

      <h2>Slide with overflow image</h2>
      <!-- first slide with image overflow -->
      <overflow-image-slide v-bind:image="example_image">

        <h2 class="upcase">why should I care?</h2>
        <p>Too often, childhood trauma is misdiagnosed and misunderstood. On the outside, its victims look just like regular kids. But on the inside, these kids have been affected emotionally, mentally, and even physically. So much so that their brain development can actually be affected and changed.</p>
        <p>As with an iceberg,  there’s much more below the surface than above it. Issues that present themselves in a classroom such as absenteeism, poor grades or aggression often are symptoms of the very broad-based, complex issue of trauma.</p>
        <p>The good news is, we can help kids heal.</p>

      </overflow-image-slide>

      <!-- utility spacers -->
      <div class="style-guide-spacer"></div>

      <h2>Full span slide</h2>
      <!-- full span slide -->
      <full-span-slide>

        <h1 class="upcase">HELPING children IMPACTED BY trauma TO HEAL AND THRIVE</h1>

        <p>Exposure to violence in the community or at home can impact students  psychologically, socially, academically, and behaviorally. It often results in trauma, diminished health outcomes, low academic achievement, classroom management issues and a hastened dispatch to child welfare or juvenile justice system--particularly for students of color.</p>
        
        <p>While the issue of children’s exposure to violence and trauma is not new for schools, there are now even more promising practices that can help our schools do what they do best - educate.</p>

      </full-span-slide>

      <div class="style-guide-spacer"></div>

      <!-- full span with radio buttons -->
      <full-span-slide>

        <p class="large">Which of these “symptoms” may be an indication of underlying trauma in a child?</p>

        <div class="row">
          <radio-span>not bold</radio-span>
          <radio-span strong>is bold</radio-span>
          <radio-span>etc</radio-span>
        </div>

      </full-span-slide>

      <div class="style-guide-spacer"></div>

      <h2>Share Cards</h2>
      <!-- share cards slide -->
      <header-block>Did you know?</header-block>

      <div class="row">
        <share-card bump="bump-up">

          <p><strong>Approximately 30% of children</strong> report moderate or frequent involvement in bullying in some capacity.viii Children involved in bullying in any capacity report higher rates of victimization in the home and community than their peers.</p>

        </share-card>

        <share-card bump="bump-down">

          <p><strong>Youth ages 10 to 17</strong> who had engaged in delinquent behavior in the past year reported higher rates of exposure to violence than their peers who reported little or no delinquent behavior. Youth who have been exposed to violence are at a higher risk to engage in criminal behavior later in life.</p>

        </share-card>
      </div>

      <div class="style-guide-spacer"></div>

      <!-- flip card slide is already covered in molecules. -->

      <h2>Progress selector slide</h2>
      <!-- progress selector slide -->
      <!-- todo: clean this up/add functionality -->
      <header-block>Protective Factors that Promote Resiliency: Individual</header-block>

      <div class="row align-center">

        <div class="span-9-lg offset-1-lg span-8-md overflow-hidden">
          
          <progress-selector>one</progress-selector>
          <progress-selector>two</progress-selector>
          <progress-selector>three</progress-selector>
          <progress-selector>four</progress-selector>
          <progress-selector>five</progress-selector>
          <progress-selector>six</progress-selector>
          <progress-selector>seven</progress-selector>

        </div>

        <rollover-card spanclass="span-4-lg offset-1-lg span-7-md offset-1-md span-16-sm span-16-xs" ratioclass="ratio-3-4">
          <h3>content here</h3>
        </rollover-card>

      </div>

    </div>



    <!-- navbar -->
    <navbar></navbar>

  </div>
</template>

<script>

  import radio_span from '../../components/molecules/radio_span'

  import rollover_card from '../../components/molecules/rollover_card'
  import progress_selector from '../../components/molecules/progress_selector'

  import navbar from '../../components/organisms/navbar'
  import overflow_image_slide from '../../components/organisms/overflow_image_slide'
  import full_span_slide from '../../components/organisms/full_span_slide'
  import header_block from '../../components/organisms/header_block'
  import share_card from '../../components/organisms/share_card'

  export default {
    data () {
      return {
        example_image: 'https://s3-us-west-2.amazonaws.com/fwov-vpv/temp.png'
      }
    },
    components: {
      'navbar': navbar,
      'overflow-image-slide': overflow_image_slide,
      'full-span-slide': full_span_slide,
      'radio-span': radio_span,
      'header-block': header_block,
      'share-card': share_card,
      'rollover-card': rollover_card,
      'progress-selector': progress_selector
    }
  }
</script>

<style scoped lang="scss">
  .style-guide-spacer {
    position: relative;
    display: block;
    width: 100%;
    height: 96px;
  }
</style>


// WEBPACK FOOTER //
// organisms.vue?1dc2771f